import { UploadedFile } from "./uploaded-file.model";

export const PLASTICS_HARDWARE_ITEM_SHIPMENT_DAMAGE_CAM_PRESENCE_DAMAGE_ITEM_ID = 'presence';

export interface PlasticsHardwareItemShipmentDamageCamEntry {
	damageItemId: string;
	plasticsHardwareItemShipmentId: string;
	files: UploadedFile[];
	qrScanDate: Date;
	userId: string;
}

export interface PlasticsHardwareItemShipmentDamageCamQRCodeDialogArgs {
	plasticsHardwareItemShipmentId: string;
}
